import React from "react";

export default function Section3() {
  return (
    <div className="bg-white py-24 flex justify-center  bg-contain bg-center bg-no-repeat" style={{backgroundImage: "url('/assets/img/2022.svg')"}}>
      <p className="w-[60%] text-[#151519] font-normal text-center leading-loose">
      Trade, stake, and explore with a wallet built for true decentralization. CrypWallet enables secure transactions, NFT management, DEX trading, and seamless DApp access, all while optimizing gas fees and protecting your assets with top-tier encryption.
      </p>
    </div>
  );
}
